// pages/Dashboard.jsx
import BookDetails from "../../components/home/booksDetailsComponents.jsx/BookDetails";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <BookDetails />
    </HomeLayout>
  );
}


